// Экран-состояние (задача D4): «Нет доступа», «Такой страницы нет», ошибка экрана, заглушка раздела. Значок в круге,
// заголовок `h1` (после перехода на него ставит фокус каркас D5), пояснение и одно действие.
import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

export interface StateScreenProps {
  readonly icon: LucideIcon;
  readonly title: string;
  readonly children?: ReactNode;
  /** Единственное действие экрана — главная кнопка. */
  readonly action?: ReactNode;
}

export function StateScreen({ icon: Icon, title, children, action }: StateScreenProps) {
  return (
    <section className="flex min-h-[inherit] flex-col items-center justify-center px-6 py-16 text-center max-sm:px-4">
      <div className="flex max-w-105 flex-col items-center gap-3">
        <span className="flex size-9 items-center justify-center rounded-full bg-muted text-muted-foreground">
          <Icon aria-hidden="true" className="size-4" />
        </span>
        <h1 tabIndex={-1} className="text-xl font-semibold text-balance">
          {title}
        </h1>
        {children !== undefined && <div className="flex flex-col gap-1 text-pretty text-muted-foreground">{children}</div>}
        {action !== undefined && <div className="mt-2">{action}</div>}
      </div>
    </section>
  );
}
